import { Button } from "@components/Button";
import { ErrorComponent } from "@components/ErrorComponent";
import { Row } from "@components/Flex";
import { SelectionInput, TextInput } from "@components/Input";
import { Loader } from "@components/Loader";
import { MainLayout, MainLayoutProps } from "@components/MainLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { DateFormat, State } from "@ctypes";
import { useModal, useUser } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Separator } from "@routes/VerifiedRoute/styles";
import { formatPhoneNumber } from "@utils";
import dayjs from "dayjs";
import { ChangeDetailsModal } from "./ChangeDetailsModal";
import { styles } from "./styles";

export const PersonalInformationRoute = () => {
  const props: MainLayoutProps = {
    pageHeader: i18n.t(Translations.PersonalDetailsRouteTitle),
  };

  const { show } = useModal();

  const { user, loading, error } = useUser();

  const defaultStateIndex = Object.values(State).findIndex((s) => s === user?.userAddress?.state);

  const showChangeDetailsModal = () => {
    show(<ChangeDetailsModal />);
  };

  if (loading) return <Loader />;
  if (error) return <ErrorComponent />;

  return (
    <MainLayout {...props}>
      <TextInput
        label={i18n.t(Translations.NameRouteFirstNameLabel)}
        value={user?.firstName ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.NameRouteLastNameLabel)}
        value={user?.lastName ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.VerifiedRouteEmailLabel)}
        value={user?.email ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.VerifiedRoutePhoneNumberLabel)}
        value={formatPhoneNumber(user?.phoneNumber ?? "")}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.DateOfBirthRouteInputLabel)}
        value={dayjs(user?.dateOfBirth).format(DateFormat.FullDate)}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.AddressFormAddressLabel)}
        value={user?.userAddress?.street ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.AddressFormUnitNoLabel)}
        value={user?.userAddress?.unitNo ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <Row>
        <TextInput
          label={i18n.t(Translations.AddressFormCityLabel)}
          value={user?.userAddress?.city ?? ""}
          readOnly
          style={styles.input}
        />

        <Separator />

        <SelectionInput
          label={i18n.t(Translations.AddressFormStateLabel)}
          items={Object.values(State)}
          defaultIndex={defaultStateIndex >= 0 ? defaultStateIndex : 0}
          readOnly
        />
      </Row>
      <Spacing size={SpacingSizes.S} />

      <TextInput
        label={i18n.t(Translations.AddressFormZipCodeLabel)}
        value={user?.userAddress?.postalCode ?? ""}
        readOnly
        style={styles.input}
      />
      <Spacing size={SpacingSizes.S} />

      <Button
        title={i18n.t(Translations.PersonalDetailsRoutePrimaryCTA)}
        onClick={showChangeDetailsModal}
      />
      <Spacing size={SpacingSizes.S} />
    </MainLayout>
  );
};
